import styled from "@emotion/styled"
import Theme from "../lib/Theme"

export const SocialIcon = styled.a<{ color: string; inverted?: boolean }>`
  display: inline-flex;
  overflow: hidden;
  position: relative;

  width: 2rem;
  height: 2rem;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;

  border-radius: 5px;
  background: ${(p) => (p.inverted ? p.color : "#eee")};
  transition: background-color 0.2s ease-in-out;

  svg {
    position: absolute;
    display: block;
    width: 1rem;
    height: 1rem;
    fill: ${Theme.Colors.purple.s50};
    transition: transform 0.2s ease-in-out;

    &:nth-of-type(2) {
      fill: #fff;
      top: 2rem;
    }
  }

  &:hover {
    background: ${(p) => p.color};

    svg {
      transform: translateY(-1.5rem);
    }
  }
`
